export default "__VITE_ASSET__bee25442__"